import { render, staticRenderFns } from "./ResearchAndInsights.vue?vue&type=template&id=5577c5a8&scoped=true"
import script from "./ResearchAndInsights.vue?vue&type=script&lang=js"
export * from "./ResearchAndInsights.vue?vue&type=script&lang=js"
import style0 from "./ResearchAndInsights.vue?vue&type=style&index=0&id=5577c5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5577c5a8",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QCard,QCardSection,QImg,QCircularProgress,QAvatar,QCardActions,QSpace,QBtn});qInstall(component, 'directives', {Ripple});
